import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselModule } from '@app/components/carousel/carousel.module';
import { BlockUlComponent } from '@app/components/blocks/block-ul/block-ul.component';
import { PlUlModule } from '@app/components/pl-ul/pl-ul.module';

@NgModule({
  imports: [CommonModule, CarouselModule, PlUlModule],
  declarations: [BlockUlComponent],
  exports: [BlockUlComponent],
})
export class BlockUlModule {}
